import React from 'react';
import PropTypes from 'prop-types';
import Heading from '@cotyorg/ccx-atoms/Heading/Heading';
import { CardsCarousel } from '@cotyorg/ccx-organism-carousel';
import R from 'ramda';
import SectionHeader from '../../../atoms/SectionHeader';

export const RealStoriesSection = ({ sectionHeading }) => (
  <div className="real-stories article-section">
    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell">
          <SectionHeader>
            <Heading level={2}>{R.prop('heading', sectionHeading)}</Heading>
          </SectionHeader>
          <SectionHeader>
            <Heading level={3} alignment="center">
              {R.prop('introduction', sectionHeading)}
            </Heading>
          </SectionHeader>
        </div>
      </div>
    </div>
    <CardsCarousel
      cards={{
        cardsStoreDataKey: 'realStoriesCarousel',
        isTitleUnderlined: false,
        hasBackground: false,
        isSmallTitle: true,
        zoomOnHover: false,
        fixedHeight: false,
        showStarRating: false,
      }}
      carousel={{
        carouselsStoreDataKey: 'realStoriesCarousel',
        headingLevel: 4,
        rightChevronIconSrc: '/ccx-files/assets/arrow-right.svg',
        leftChevronIconSrc: '/ccx-files/assets/arrow-left.svg',
      }}
    />
  </div>
);

RealStoriesSection.propTypes = {
  sectionHeading: PropTypes.instanceOf(PropTypes.object),
};
